import { request } from '@/shared/api/request'

export const getFLData = (params) => request({ url: '/contract/universalMethods/requestFlData', method: 'GET', params })

export const getXmlForUpdateIin = (data) => request({ url: '/contract/changeIin/xml', method: 'POST', data })

export const sendUpdateIinXml = (data) => request({ url: '/contract/sendChangeIinData', method: 'POST', data })
